import React, { useState } from 'react';
import axios from 'axios';
import { API_URL } from '../utils/constants';

function ExternalStatisticsTable() {
  const [statistics, setStatistics] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const fetchExternalStatistics = async () => {
    setLoading(true);
    setError('');
    try {
      const params = new URLSearchParams({
        ...(startDate && { start_date: startDate }),
        ...(endDate && { end_date: endDate }),
      });

      const response = await axios.get(`${API_URL}/admin/read/external-statistics?${params.toString()}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setStatistics(response.data);
    } catch (err) {
      setError('Failed to fetch external statistics: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto p-4 bg-black rounded-xl border border-gray-800">
      <h1 className="text-2xl font-bold text-center text-white mb-6">External API Usage Statistics</h1>
      <div className="flex justify-center mb-4">
        <input
          type="date"
          className="mx-2 p-2 text-black"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />
        <input
          type="date"
          className="mx-2 p-2 text-black"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
        <button
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
          onClick={fetchExternalStatistics}
        >
          Fetch Statistics
        </button>
      </div>
      {loading ? (
        <p>Loading statistics...</p>
      ) : error ? (
        <p className="text-red-500">{error}</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full leading-normal bg-black border-collapse">
            <thead>
              <tr>
                <th className="px-5 py-3 border-b-2 border-gray-500 text-left text-xs font-semibold text-white uppercase tracking-wider">
                  Distributor Name
                </th>
                <th className="px-5 py-3 border-b-2 border-gray-500 text-left text-xs font-semibold text-white uppercase tracking-wider">
                  Request Name
                </th>
                <th className="px-5 py-3 border-b-2 border-gray-500 text-left text-xs font-semibold text-white uppercase tracking-wider">
                  Request URL
                </th>
                <th className="px-5 py-3 border-b-2 border-gray-500 text-left text-xs font-semibold text-white uppercase tracking-wider">
                  Count
                </th>
              </tr>
            </thead>
            <tbody>
              {statistics.map((stat, index) => (
                <tr key={index} className="bg-gray-800 hover:bg-gray-600">
                  <td className="px-5 py-5 border-b border-gray-800 text-sm">
                    {stat.distributor_name}
                  </td>
                  <td className="px-5 py-5 border-b border-gray-800 text-sm">
                    {stat.request_name}
                  </td>
                  <td className="px-5 py-5 border-b border-gray-800 text-sm">
                    {stat.request_url}
                  </td>
                  <td className="px-5 py-5 border-b border-gray-800 text-sm">
                    {stat.count}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default ExternalStatisticsTable;